module.exports = __webpack_public_path__ + "9e53f6250329f10eeb02884634b9ea1d.MP3";